export const LOGIN_ACTION = 'auth/LOGIN_ACTION';
export const LOGOUT_ACTION = 'auth/LOGOUT_ACTION';
export const REFRESH_TOKEN_ACTION = 'auth/REFRESH_TOKEN_ACTION';
export const VALIDATE_LOGIN_ACTION = 'auth/VALIDATE_LOGIN_ACTION';
export const SAVE_USER_INFO_ACTION = 'auth/SAVE_USER_INFO_ACTION';



// WEBPACK FOOTER //
// ./src/common/action-types/auth.js